import { Component, OnInit } from '@angular/core';
import { FormuleFormComponent } from '../formules/formule-form/formule-form.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiProviderService } from '../../../services/api-provider.service';
import { ModalController } from '@ionic/angular';
import { UserService } from '../../../services/user.service';
import { Formule } from '../../../models/formule';
import { Abonnement } from '../../../models/abonnement';
import { User } from 'src/app/micro-services/user/models/user';

@Component({
  selector: 'app-abonnement-form',
  templateUrl: './abonnement-form.component.html',
  styleUrls: ['./abonnement-form.component.scss'],
})
export class AbonnementFormComponent implements OnInit {

  abonnementForm : FormGroup;
  client : User;
  formules: Formule[] = [];
  abonnement : Abonnement = new Abonnement();
  public bool : Boolean = true
  

  constructor(
    private builder : FormBuilder,
    private userService : UserService,
    private apiProvider : ApiProviderService,
    private modalCtrl : ModalController,

  ) { }

  ngOnInit() {
    this.client = this.userService.selectedClient
    let coach = this.userService.getUser();
    let coachId = coach.id;
    this.abonnementForm = this.builder.group({
      dateDebut: ['', Validators.required],
      formule: ['', Validators.required],
      recurrence : ['', Validators.required],
      paiementMod : ['', Validators.required],
    });
    this.apiProvider.getFormulesByCoach(coachId).subscribe(
      (res) => {
      this.formules= res;
    },
    (err) => {
      this.formules = [];
    },);
  }


  testType(){
    if (this.abonnementForm.invalid) {
      this.abonnementForm.markAllAsTouched();
      return;
    }
    this.validate();
  }

  validate(){
    if (this.abonnementForm.invalid) {
      return
    }
    this.abonnement.dateDebut = this.abonnementForm.controls.dateDebut.value;
    this.abonnement.recurrence = this.abonnementForm.controls.recurrence.value;
    this.abonnement.paiementMod = this.abonnementForm.controls.paiementMod.value;
    this.abonnement.formuleId = this.abonnementForm.controls.formule.value;
    this.abonnement.clientId = this.client.id;
    this.apiProvider.newAbonnementClient(this.abonnement).subscribe(
      (res : Abonnement) => {
        return this.modalCtrl.dismiss({...this.abonnementForm.value, id : res.id}, 'confirm');
      }
     );
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }


  //Modal Formule
  
  async openModalFormule(title : string) {
    const modal = await this.modalCtrl.create({
      component: FormuleFormComponent,
      componentProps:{
      title : title}
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.formules.push(data);
    }
  }
}
